import { useEffect, useState } from 'react';

/**
 * "Happening now" and the countdown are only trustworthy if the clock is. Phones at a
 * conference are routinely minutes off, so the API reports its own time and the offset
 * measured on arrival is applied to every later reading.
 */
export function useNow(serverTime: string | undefined, intervalMs = 30_000): Date {
  const [tick, setTick] = useState(() => Date.now());
  const [skewMs, setSkewMs] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setTick(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  useEffect(() => {
    if (!serverTime) {
      return;
    }
    const delta = Date.parse(serverTime) - Date.now();
    // A second or two is ordinary latency, not a wrong clock.
    setSkewMs(Math.abs(delta) > 5_000 ? delta : 0);
  }, [serverTime]);

  return new Date(tick + skewMs);
}
